export default __webpack_public_path__ + "static/media/featured_img_one.01732b73.jpg";